import { Settings } from '../../../../services/settings';
import { SelectuserComponent } from '../../../../components/selectuser/selectuser.component';
import { Component, OnInit, Input, Output, ViewChild, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { ServiceDefService } from 'src/app/services/servicedef.service';
import { CasesService } from 'src/app/services/cases.service';
import { DwUtils } from 'src/app/components/utils/dw-utils';
import { HouseholdMember } from 'src/app/models/household-member';
import { AdvancedFilterComponent } from './dialogs/advanced-filter/advanced-filter.component';
import { QualificationFilter } from 'src/app/models/qualification-filter';

@Component({
	selector: 'app-report-params',
	templateUrl: './report-params.component.html',
	styleUrls: ['./report-params.component.css']
})
export class ReportParamsComponent implements OnInit, OnChanges {

	@Input() ParamSpecs: any[];
	@Input() parent: any;
	@ViewChild('se', { static: true }) fEmployeeLookUp: SelectuserComponent;
	@ViewChild('advancedfilter', { static: true }) advancedFilterComponent: AdvancedFilterComponent;
	displayEmployeeList = false;
	displayAdvacedFilter = false;
	formDisableFlag = false;
	valResourceFullName = '';
	valSearchString = '';
	displayDelayNote = false;

	suggestions: { id: number, label: string }[] = [];
	allOptions: { id: number, label: string }[] = [];
	selectedMember: HouseholdMember;

	valSelectedEmployee = '';
	valCaseNumber = '';
	valStartDate: any;
	valEndDate: any;
	selectedAgency: any;
	selectedRegion: any;
	selectedAgencyService: any;
	selectedRequestType: any;
	selectedDateType: any;
	selectedZipCode: any;
	selectedCounty: any;
	selectedCaseStatus: any;
	selectedSource: any;
	selectedAdvancedFilterQuery: QualificationFilter[];
	isAdvanceFilterPresent = 'no';

	valSkipTeamTotal: Array<any>;
	lblMessageColor = 'foreground-red';
	lblMessage = '';
	agencyList: any;
	regionsList: any;
	countyList: any;
	agencyServiceList: any;
	allAgencyServiceDefs: any[] = [];
	requestTypeList: any;
	dateTypeList: any;
	caseStatusList: any;
	sourceList: any;

	isAdmin: boolean;
	defaultAgency: string;
	enableAdvancedButton = true;
	lblWarning = '';
	
	hasAdvancedFilter = false;
	hasAgencySelection = false;

	@Output() SubmitClicked = new EventEmitter();
	@Output() CloseClicked = new EventEmitter();

	constructor(private serviceDefService: ServiceDefService, private casesService: CasesService) {

	}

	ngOnInit() {
		
	}

	ngOnChanges(changes: SimpleChanges): void {
		if (changes['ParamSpecs'] && changes['ParamSpecs'].currentValue) {
			// ParamSpecs has been updated, initialize filter
			this.initializeFilter();
		}
	}

	public initializeFilter(): void {

		//this.selectedCaseStatus = undefined;
		//this.selectedSource = undefined;
		this.hasAdvancedFilter = Settings.getInstance().hasPrivilege('ADVANCED_REPORT_FILTER_OPTIONS', "EXECUTE");
		this.hasAgencySelection = Settings.getInstance().hasPrivilege('REPORT_FILTER_AGENCY', "EXECUTE");
		const agencyParam = this.ParamSpecs?.find(param => param.name === 'Agency');
		const defaultToUsersAgency = agencyParam?.defaultToUsersAgency === true;
		const userAgencyId = Settings.getInstance().loggedInUser.agencyId;
		this.casesService.getAllCaseStatuses().subscribe(
			(result) => {
				Settings.getInstance().caseStatusList = result;
				Settings.getInstance().caseStatusList.forEach(rec => this.caseStatusList.push({ id: rec.id, description: rec.shortDescription }));
			});

		// this.programList = AppSettings.programList;
		if (this.hasAgencySelection) {
			this.isAdmin = true;
			if (defaultToUsersAgency) {
				this.selectedAgency = userAgencyId;
				this.agencySelectHandler(userAgencyId);
			} else {
				this.selectedAgency = undefined;
				this.selectedAgencyService = undefined;
			}
		} else {
			this.isAdmin = false;
			this.defaultAgency = Settings.getInstance().getAgencyName(userAgencyId);
			this.selectedAgency = Settings.getInstance().getAgencyRecord(userAgencyId);
			this.agencySelectHandler(userAgencyId);
		}
		this.agencyList = [];
		this.regionsList = [];
		this.countyList = [];
		this.agencyServiceList = [];
		this.allAgencyServiceDefs = [];
		this.requestTypeList = [];
		this.dateTypeList = [
			{ id: 1, description: 'Created Date' },
			{ id: 2, description: 'Closed Date' }
		];
		this.caseStatusList = [];
		this.sourceList = [
			{ id: 'Universal Form', description: 'Universal' },
			{ id: 'Manual Add', description: 'Manual' }
		];
		// Add 'All agency' entry with id 0
		this.agencyList.push({ id: -1, description: 'All Agencies' });
		// Sort agencies by name
		const sortedAgencies = Settings.getInstance().agencyList
			.map(rec => ({ id: rec.id, description: rec.agencyName }))
			.sort((a, b) => a.description.localeCompare(b.description));
		sortedAgencies.forEach(agency => this.agencyList.push(agency));
		Settings.getInstance().serviceRequestTypesList.forEach(rec => this.requestTypeList.push({ id: rec.id, description: rec.description }));
		Settings.getInstance().regionsList.forEach(rec => this.regionsList.push({ id: rec.id, description: rec.description + ' - ' + rec.zipCode }));

		const uniqueCounties = new Set<string>();
		const countyArray: { id: number | null; description: string | null }[] = [];

		Settings.getInstance().regionsList.forEach((region, index) => {
			if (!uniqueCounties.has(region.county)) {
				uniqueCounties.add(region.county);
				countyArray.push({ id: region.id, description: region.county });
			}
		});
		this.countyList = countyArray;
		if(this.ParamSpecs){
			const startDateParam = this.ParamSpecs.find(param => param.name === 'StartDate');
			this.displayDelayNote = startDateParam.displayDelayNote; // Check displayDelayNote
		}
		
		

		//this.queryRecords();
	}
	queryRecords() {

	}
	showDialogEmployee() {
		this.displayEmployeeList = true;
		this.fEmployeeLookUp.queryRecords();
		this.formDisableFlag = true;
	}
	setResource(data) {
		this.valResourceFullName = data.name;
		this.valSelectedEmployee = data.username;
		this.displayEmployeeList = false;
		this.formDisableFlag = false;
	}
	CancelClickedfromSelectEmployee() {
		this.displayEmployeeList = false;
		this.formDisableFlag = false;
	}

	doRun() {
		if (this.validateFields()) {
			if (this.selectedAgency === undefined) {
				//let obj = new Object();
				//obj['Agency'] = 0;
				this.selectedAgency = -1;
			}
			this.SubmitClicked.emit();
			this.lblMessage = '';
		}
	}
	close() {
		this.lblMessage = '';
		this.CloseClicked.emit();
	}
	validateFields(): boolean {
		let ret = true;
		let startDateValid = this.valStartDate !== undefined && this.valStartDate !== null && this.valStartDate !== '';
		let endDateValid = this.valEndDate !== undefined && this.valEndDate !== null && this.valEndDate !== '';

		const hasDateType = this.ParamSpecs.some(param => param.name === 'DateType');

		if (startDateValid && endDateValid) {
			if (!this.validateDates()) {
				this.lblMessage = 'Error: Start date is greater than the end date';
				DwUtils.setFocus('startDate');
				return false;
			}
		}

		for (let i = 0; i < this.ParamSpecs.length; i++) {
			const param_obj = this.ParamSpecs[i];

			if (param_obj.isRequired === true && param_obj.name === 'UserUid' && this.valSelectedEmployee === '') {
				this.lblMessage = 'Please select Employee';
				return false;
			}
			if (param_obj.isRequired === true && param_obj.name === 'Agency' && this.selectedAgency === '') {
				this.lblMessage = 'Please select Agency';
				return false;
			}
			if (this.selectedAgency === '' && param_obj.isRequired === true && param_obj.name === 'RequestType' && this.selectedRequestType === '') {
				this.lblMessage = 'Please select Request Type';
				return false;
			}
			if (param_obj.isRequired === true && param_obj.name === 'DateType' && !this.selectedDateType) {
				this.lblMessage = 'Please select Date type';
				DwUtils.setFocus('comboDateTypes');
				return false;
			}
			if (param_obj.isRequired === true && param_obj.name === 'StartDate' && !startDateValid) {
				this.lblMessage = 'Please provide a Start date';
				DwUtils.setFocus('startDate');
				return false;
			}
			if (param_obj.isRequired === true && param_obj.name === 'MemberName' && (!this.selectedMember || !this.selectedMember.id)) {
				this.lblMessage = 'Please select a client';
				DwUtils.setFocus('txtMember');
				return false;
			}
			if (this.valStartDate) {
				if (param_obj.isRequired === true && param_obj.name === 'EndDate' && !endDateValid) {
					this.lblMessage = 'Please provide an End date';
					DwUtils.setFocus('endDate');
					return false;
				}
			}
			if (param_obj.isRequired === true && param_obj.name === 'CaseNumber' && this.valCaseNumber === '') {
				this.lblMessage = 'Please provide a Case Number';
				return false;
			}
		}

		const endDateField = this.ParamSpecs.find(field => field.name === 'EndDate' && field.maxDurationDays !== undefined);

		if (endDateField) {
			const startDate = new Date(this.valStartDate);
			const endDate = new Date(this.valEndDate);
			const durationInDays = Math.abs((endDate.getTime() - startDate.getTime()) / (1000 * 3600 * 24));

			// Compare durationInDays with maxDurationDays
			if (durationInDays > endDateField.maxDurationDays) {
				this.lblMessage = `Duration exceeds maximum of ${endDateField.maxDurationDays} days.`;
				DwUtils.setFocus('endDate');
				return false;
			}
		}

		return ret;
	}

	validateDates(): boolean {
		const startDate = new Date(this.valStartDate);
		const endDate = new Date(this.valEndDate);
		return startDate <= endDate;
	}
	agencySelectHandler(agency) {
		this.selectedAgency = agency;
		this.allAgencyServiceDefs = [];
		this.agencyServiceList = [];
		if (!agency || Number(agency) < 1) {
			this.selectedAgencyService = undefined;
			return;
		}
		this.serviceDefService.getAllServiceDefsForAgency(agency).subscribe(
			(result) => {
				Settings.getInstance().serviceDefsList = result;
				this.allAgencyServiceDefs = result;
				this.clearInvalidAgencyServiceSelection();
				this.refreshAgencyServiceList();
			},
			(error) => {
				Settings.getInstance().handleError('Error: unable to retrieve agencies services');
			}
		);
	}
	requestTypeSelectHandler(requestTypeId) {
		this.selectedRequestType = requestTypeId;
		this.selectedAgencyService = undefined;
		this.refreshAgencyServiceList();
	}
	clearRequestType() {
		this.selectedRequestType = undefined;
		this.selectedAgencyService = undefined;
		this.refreshAgencyServiceList();
	}
	clearAgency() {
		this.selectedAgency = undefined;
		this.selectedAgencyService = undefined;
		this.allAgencyServiceDefs = [];
		this.refreshAgencyServiceList();
	}
	refreshAgencyServiceList() {
		this.agencyServiceList = [];
		if (!this.selectedAgency || Number(this.selectedAgency) < 1 || !this.selectedRequestType) {
			return;
		}
		this.allAgencyServiceDefs
			.filter(rec => rec.serviceRequestTypeId === this.selectedRequestType)
			.forEach(rec => this.agencyServiceList.push({ id: rec.id, description: rec.description }));
	}
	clearInvalidAgencyServiceSelection() {
		if (!this.selectedAgencyService) {
			return;
		}
		const stillValid = this.allAgencyServiceDefs.some(
			rec => rec.id === this.selectedAgencyService
				&& (!this.selectedRequestType || rec.serviceRequestTypeId === this.selectedRequestType)
		);
		if (!stillValid) {
			this.selectedAgencyService = undefined;
		}
	}
	regionSelectHandler(regionId) {
		this.selectedZipCode = Settings.getInstance().regionsList.find(region => region.id === regionId).zipCode;
		this.selectedRegion = regionId;
	}
	clearRegion() {
		this.selectedZipCode = undefined;
		this.selectedRegion = undefined;
	}

	countySelectHandler(countyId) {
		this.selectedCounty = Settings.getInstance().regionsList.find(region => region.id === countyId).county;
		this.selectedRegion = countyId;
	}
	clearCounty() {
		this.selectedCounty = undefined;
		this.selectedRegion = undefined;
	}

	search(event) {
		const query = event.query.toLowerCase();
		if (query.length >= 3) {
			this.casesService.searchMember(query).subscribe(data => {
				this.allOptions = data.map(member => ({ id: member.id, label: `${member.firstName} ${member.lastName}` }));
				this.filterSuggestions(query);
			});
		} else {
			this.suggestions = [];
		}
	}

	filterSuggestions(query: string) {
		this.suggestions = this.allOptions.filter(option => option.label.toLowerCase().includes(query));
	}
	showDialogAdvancedFilter() {
		this.displayAdvacedFilter = true;
		this.advancedFilterComponent.onShowHandler();
	}

	submitClickedFromAdvancedFilter(event) {
		if (event !== '') {
			this.selectedAdvancedFilterQuery = event;
			this.isAdvanceFilterPresent = 'present';
		} else {
			this.isAdvanceFilterPresent = 'no';
			this.selectedAdvancedFilterQuery = undefined;
		}

		this.displayAdvacedFilter = false;
	}
	resetClickedFromAdvancedFilter(event) {
		this.isAdvanceFilterPresent = 'no';
		this.selectedAdvancedFilterQuery = undefined;
	}

	checkDateDurationWarning() {
		if (!this.valStartDate || !this.valEndDate) {
			this.lblWarning = '';
			return;
		}

		// Check if durationWarning is enabled for StartDate
		const startDateParam = this.ParamSpecs.find(param => param.name === 'StartDate');
		const displayWarning = startDateParam && startDateParam.durationWarning;

		if (!displayWarning) {
			this.lblWarning = '';
			return; // Early return if warning is disabled
		}

		const startDate = new Date(this.valStartDate);
		const endDate = new Date(this.valEndDate);
		const durationInDays = Math.abs((endDate.getTime() - startDate.getTime()) / (1000 * 3600 * 24));

		// Check if no other filters are selected
		const otherFiltersEmpty =
			!this.valSelectedEmployee &&
			!this.valCaseNumber?.trim() &&
			!this.valSearchString?.trim() &&
			(this.selectedAgency === undefined || this.selectedAgency === null || this.selectedAgency === -1) &&
			!this.selectedRegion &&
			!this.selectedAgencyService &&
			!this.selectedRequestType &&
			!this.selectedDateType &&
			!this.selectedZipCode &&
			!this.selectedCounty &&
			!this.selectedCaseStatus &&
			!this.selectedSource &&
			!this.selectedAdvancedFilterQuery &&
			!this.selectedMember;

		if (durationInDays > 14 && otherFiltersEmpty) {
			this.lblWarning = 'Warning: Date range exceeds 14 days. Please consider adding filters.';
		} else {
			this.lblWarning = '';
		}
	}

}




